import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class ProjectsService {

  getProjects = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', entitiesId = null) => {
   
    let params = `page=${pageNum}&search=${search}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`
    
    if (entitiesId) {
        params += `&entitiesId=${entitiesId}`
    }

    return await axios.get(API_URL + '/projects?' + params, { headers: authHeader() })
}

  // Add new project
  addProject = async (project) => {
    return await axios.post(API_URL + '/projects', project, { headers: authHeader() })
  }

  // Update project data
  updateProject = async (project, id) => {
    return await axios.patch(API_URL + '/projects/' + id, project, { headers: authHeader() })
  }

  // Get project data
  getProject = async (id) => {
    return await axios.get(API_URL + '/projects/' + id, { headers: authHeader() })
  }

  // Delete project
  deleteProject = async (id) => {
    return await axios.delete(API_URL + '/projects/' + id, { headers: authHeader() })
  }

}

export default new ProjectsService()